class KsMarqueeSection extends HTMLElement {
  constructor() {
    super();
    this.track = this.querySelector('.ks-marquee-track');
    this.list = this.querySelector('.ks-marquee-list');
  }

  connectedCallback() {
    if (!this.track || !this.list) return;

    // Use IntersectionObserver to start logic only when close to viewport
    const observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        this.init();
        observer.disconnect();
      }
    }, { rootMargin: '0px 0px 50px 0px' });

    observer.observe(this);
  }

  init() {
    this.ensureContentFillsScreen();
    this.enableAnimation();
  }

  ensureContentFillsScreen() {
    // 1. Check if the current list is wider than the screen
    const screenWidth = window.innerWidth;
    const initialChildren = [...this.list.children];
    
    // Safety break to avoid infinite loops
    let safetyCounter = 0;
    
    // Clone items into the original list until it is at least as wide as the screen
    // We check scrollWidth against screenWidth * 1.5 to provide a buffer
    while (this.list.scrollWidth < screenWidth * 1.5 && safetyCounter < 50) {
      initialChildren.forEach(child => {
        this.list.appendChild(child.cloneNode(true));
      });
      safetyCounter++;
    }

    // 2. IMPORTANT: Clone the ENTIRE list to creating the seamless loop.
    // The Track will contain: [UL (Original Extended)] [UL (Clone)]
    // We animate the Track to move exactly -50% (the width of one UL).
    const cloneList = this.list.cloneNode(true);
    cloneList.setAttribute('aria-hidden', 'true');
    this.track.appendChild(cloneList);
  }

  enableAnimation() {
    // We simply add a class that triggers the CSS animation.
    // This is more robust than JS animations when the main thread is busy.
    this.track.classList.add('is-animating');
  }
}

if (!customElements.get('ks-marquee-section')) {
  customElements.define('ks-marquee-section', KsMarqueeSection);
}